module.exports = __webpack_public_path__ + "img/Logo_ActorsChallenge-2 2blanco.baca859a.svg";